export default __webpack_public_path__ + "static/media/houseimage4.8fdc0c24.png";